import { TableCellTypes } from '@carboledger/ui';
import { makeSerialCell } from '@/components/common';
import { BACK_TO_BACK_COLUMNS, BACK_TO_BACK_SORT_FIELDS } from './backToBackAccounts.constants';

const canSort = (id) => Boolean(BACK_TO_BACK_SORT_FIELDS[id]);

export const buildBackToBackAccountsColumns = (t, { serialOffset = 0 } = {}) =>
  [
    {
      id: BACK_TO_BACK_COLUMNS.serialNo,
      header: t('FIELD_SERIAL_NO'),
      type: TableCellTypes.custom,
      width: 80,
      cell: makeSerialCell(serialOffset),
    },
    {
      id: BACK_TO_BACK_COLUMNS.accountName,
      header: t('FIELD_ACCOUNT_NAME'),
      type: TableCellTypes.text,
      width: 160,
      pinnable: true,
    },
    {
      id: BACK_TO_BACK_COLUMNS.accountId,
      header: t('FIELD_ACCOUNT_ID'),
      type: TableCellTypes.text,
      width: 140,
    },
    {
      id: BACK_TO_BACK_COLUMNS.isccCertificateNumber,
      header: t('FIELD_ISCC_CERTIFICATE_NUMBER'),
      type: TableCellTypes.text,
      width: 240,
    },
    {
      id: BACK_TO_BACK_COLUMNS.officialSiteName,
      header: t('FIELD_OFFICIAL_SITE_NAME'),
      type: TableCellTypes.text,
      width: 180,
    },
    {
      id: BACK_TO_BACK_COLUMNS.addressLine1,
      header: t('FIELD_ADDRESS_LINE_1'),
      type: TableCellTypes.text,
      width: 160,
    },
    {
      id: BACK_TO_BACK_COLUMNS.addressLine2,
      header: t('FIELD_ADDRESS_LINE_2'),
      type: TableCellTypes.text,
      width: 160,
    },
    {
      id: BACK_TO_BACK_COLUMNS.cityName,
      header: t('FIELD_CITY_NAME'),
      type: TableCellTypes.text,
      width: 120,
    },
    {
      id: BACK_TO_BACK_COLUMNS.countryName,
      header: t('FIELD_COUNTRY_NAME'),
      type: TableCellTypes.text,
      width: 140,
    },
    {
      id: BACK_TO_BACK_COLUMNS.zipCode,
      header: t('FIELD_ZIP_CODE'),
      type: TableCellTypes.text,
      width: 100,
    },
  ].map((column) => ({ ...column, sortable: canSort(column.id) }));
